<template>
  <div class="home-wrapper">
    <div class="text-container">
      <div class="homeasset">Login to claim<br>your assets</div>
      <div class="homeclaim">Through the LuxTag WebApp, customers are able to claim the ownership using the unique QR code.</div>
      <div class="homedownload" > Download Now!</div>
      <div class="imagedownload">
        <img width="35%" class="clickbait" v-on:click="apple()" src="../assets/img/apps-store-button.png" >
        <img width="35%" class="clickbait" v-on:click="android()" src="../assets/img/google-play-button.png" >
      </div>
    </div>
    <img class="phones" src="../assets/img/mobile-phone-screen-disply.png">
  </div>
</template>

<script>
import { EyeIcon } from 'vue-feather-icons';
import iziToast from 'izitoast';

export default {
  name: 'home',
  methods: {
    login() {
      this.$router.push('/login');
    },
    apple() {
      window.open('https://itunes.apple.com/my/app/luxtag-user/id1390254611');
    },
    android() {
      window.open('https://play.google.com/store/apps/details?id=io.luxtag.user');
    },
  },
  mounted() {
    iziToast.destroy();
  },
  components: {
    EyeIcon,
  },
};
</script>

<!-- You can add "scoped" attribute to limit CSS to this component only -->
<!-- Be carful this can reduce performance -> https://vue-loader.vuejs.org/en/features/scoped-css.html -->
<style lang="scss">
.home-wrapper {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  text-align: left;
  width: 100%;
  background-color : transparent;
  background: url("../assets/img/element-stars.png");
  background-repeat: no-repeat;
  // background-size:  100% 100% ; 
  background-size:  900px 487px ; 
  background-position: -10px 30px;
  // height: 100%;
  .text-container {
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    flex-direction: column;
    z-index: 1;
    margin-left: 10%;
    margin-bottom: 10%;
  }
}

@media screen and (max-width: 768px) {
  .home-wrapper {
    align-items: flex-start;
  }
  .text-container {
    margin-bottom: 0% !important; 
  }
  .homeclaim {
    width: 39.5% !important;
  }
}

@media screen and (max-width: 425px) {
  .home-wrapper {
    flex-direction: column-reverse;
    align-items: center;
  }
  .text-container {
    align-items: center !important;
    margin-left: 0% !important;
    margin-bottom: 0% !important;
  }
  .imagedownload {
    align-items: center !important;
    justify-content: center !important;
  }
  .phones {
    position: relative !important;
    width: 80% !important;
    height: unset !important;
  }
  .homeasset {
    text-align: center !important;
  }
  .homeclaim {
    width: auto !important;
    text-align: center !important; 
    margin-bottom: 5%;
  }
}

.homeasset{
  color: #ffffff;
  font-size : 40px;
  letter-spacing: 0.5px;
  text-align: left;
  line-height: 1.04;
  font-family: HelveticaNeue;
}
.homeclaim{
  color: #ffffff;
  font-size: 15px;
  width: 50%;
  opacity: 0.8;
  line-height: 2.1;
  text-align: left;
}

.homedownload{
  color: #ffffff;
  font-size : 15px;
  line-height: 2.1;
  text-align: left;
}

.imagedownload{
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.h1 {
  font-size: 5.3em;
  margin: 0;
  margin-left: 50px;
  font-family: HelveticaNeue;
}
.eye {
  position: relative;
  display: inline-block;
}
.image {
  position: fixed;
}

.phones {
  display: flex;
  position: absolute;
  height: 100%;
  bottom: 0%;
  right: 0%;
  width: unset;
  z-index: 0;
}

.clickbait {
  cursor: pointer;
}

.eye::before {
  content: '';
  border-bottom: 9px solid #409EFF;
  width: 120%;
  position: absolute;
  right: -10%;
  top: 50%;
  transform: rotate(-45deg);
}

</style>



// WEBPACK FOOTER //
// Home.vue?c3f974e2